"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttemptStatisticsResponse = void 0;
class AttemptStatisticsResponse {
    constructor() {
    }
    static getAttributeTypeMap() {
        return AttemptStatisticsResponse.attributeTypeMap;
    }
}
exports.AttemptStatisticsResponse = AttemptStatisticsResponse;
AttemptStatisticsResponse.discriminator = undefined;
AttemptStatisticsResponse.attributeTypeMap = [
    {
        "name": "data",
        "baseName": "data",
        "type": "AttemptStatisticsData",
        "format": ""
    },
    {
        "name": "endDate",
        "baseName": "endDate",
        "type": "Date",
        "format": "date-time"
    },
    {
        "name": "period",
        "baseName": "period",
        "type": "StatisticsPeriod",
        "format": ""
    },
    {
        "name": "startDate",
        "baseName": "startDate",
        "type": "Date",
        "format": "date-time"
    }
];
//# sourceMappingURL=AttemptStatisticsResponse.js.map